export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmYUtfChc4AMP6lbBP.661646f2.woff2";